import gsap from "gsap";
import ScrollMagic from "scrollmagic";
import { is_mobile } from "./utils";

function playVideo(video) {
  let offset = $(".header").height() + $(".navbox").outerHeight();
  offset = is_mobile ? offset : 0;
  let box = video.getBoundingClientRect();

  video.currentTime = 0;
  video.play();

  if (box.top < offset) {
    $("html, body").animate(
      {
        scrollTop: $(video).offset().top - offset,
      },
      500,
      "swing"
    );
  }
}

function play_asist_video(controller, scrollingScenes) {
  let played = false;
  let playButton = $(".main-asist__play a");
  let asistVideo = document.querySelector("#asistVideo");
  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-asist__video",
    triggerHook: 0.6,
  })
    .on("enter", function () {
      if (!played) {
        asistVideo.play();
        played = true;

        if (asistVideo.readyState >= 1) {
          asistVideo.play();
          played = true;
        } else {
          asistVideo.addEventListener("canplay", function () {
            asistVideo.play();
            played = true;
          });
        }
      }
    })
    .addTo(controller);

  scrollingScenes.push({
    scene: scene,
  });

  asistVideo.addEventListener("play", function () {
    gsap.to(playButton, {
      opacity: 0,
      duration: 0.3,
    });
  });

  asistVideo.addEventListener("ended", function () {
    gsap.to(playButton, {
      opacity: 1,
      duration: 0.3,
    });
  });

  playButton.on("click", function (e) {
    e.preventDefault();
    playVideo(asistVideo);
  });
}

function play_box_video(controller, scrollingScenes) {
  [].forEach.call(
    document.querySelectorAll(".video-wrapper video"),
    function (video) {
      let played = false;
      let scene = new ScrollMagic.Scene({
        triggerElement: video.closest(".video-wrapper"),
        triggerHook: 0.6,
      })
        .on("enter", function () {
          if (!played) {
            video.play();
            played = true;

            if (video.readyState >= 1) {
              video.play();
              played = true;
            } else {
              video.addEventListener("canplay", function () {
                video.play();
                played = true;
              });
            }
          }
        })
        .addTo(controller);

      scrollingScenes.push({
        scene: scene,
      });

      video.addEventListener(
        "ended",
        () => {
          video.play();
        },
        false
      );
    }
  );
}

function play_suspension_video(controller, scrollingScenes, pause) {
  let played = false;
  let playButton = $(".main-suspension__play a:not(.play-reel)");
  let suspensionVideo = document.querySelector("#suspensionVideo");
  let scene = new ScrollMagic.Scene({
    triggerElement: ".main-suspension__image",
    triggerHook: 0.6,
  })
    .on("enter", function () {
      if (!played) {
        suspensionVideo.play();
        played = true;

        if (suspensionVideo.readyState >= 1) {
          suspensionVideo.play();
          played = true;
        } else {
          suspensionVideo.addEventListener("canplay", function () {
            suspensionVideo.play();
            played = true;
          });
        }
      }
    })
    .addTo(controller);

  scrollingScenes.push({
    scene: scene,
  });

  suspensionVideo.addEventListener("play", function () {
    // gsap.to(playButton, {
    //     opacity: 0,
    //     duration: 0.3
    // })
  });

  if (pause) {
    suspensionVideo.addEventListener("ended", video_delay, false);
  } else {
    suspensionVideo.addEventListener(
      "ended",
      () => {
        suspensionVideo.play();
      },
      false
    );
  }

  function video_delay(e) {
    setTimeout(function () {
      suspensionVideo.play();
    }, 1000);
  }

  playButton.on("click", function (e) {
    e.preventDefault();

    playVideo(suspensionVideo);
  });
}

function set_main_video_position() {
  let aspectRatio = window.innerHeight / window.innerWidth;

  let videoHeight = $(".main__video video").height();

  let $mainVideo = $(".main__video");
  if (aspectRatio > 0.75 || videoHeight > window.innerHeight) {
    $mainVideo.addClass("mainVideoCenter");
    $mainVideo.removeClass("mainVideoCover");
  } else if (aspectRatio <= 0.75 || aspectRatio > 0.6) {
    $mainVideo.addClass("mainVideoCover");
    $mainVideo.removeClass("mainVideoCenter");
  } else {
    $mainVideo.removeClass("mainVideoCover");
    $mainVideo.removeClass("mainVideoCenter");
  }
}

export {
  play_asist_video,
  play_suspension_video,
  set_main_video_position,
  play_box_video,
};
